import { render } from "./UserProfileMenu.vue?vue&type=template&id=5e90d48e&scoped=true"
import script from "./UserProfileMenu.vue?vue&type=script&lang=js"
export * from "./UserProfileMenu.vue?vue&type=script&lang=js"

import "./UserProfileMenu.vue?vue&type=style&index=0&id=5e90d48e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e90d48e"]])

export default __exports__